import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { INgxCrudLayout } from '../../_models/_crud-layout';
import { DynamicFormBaseComponent } from '../../../core/_base/dynamic-form.base';
import { FormBuilder } from '@angular/forms';
import { INgxPrimengForm } from 'ngx-primeng-form';
import { INgxCrudAction, INgxCrudActionCallback } from '../../_models/_crud-manage';
import { NgxUtility } from '../../../core/_utility/utility';
import * as _ from 'lodash';

@Component({
  selector: 'ngx-crud-manage',
  templateUrl: './ngx-crud-manage.component.html',
  styleUrls: ['./ngx-crud-manage.component.css']
})
export class NgxCrudManageComponent extends DynamicFormBaseComponent<any> implements OnInit, OnDestroy {

  // define form items
  _formItems: INgxPrimengForm[] = [];

  // layout instance
  @Input() layout: INgxCrudLayout;
  // action 
  @Output() onAction = new EventEmitter<INgxCrudActionCallback>();

  // pre data optional
  @Input() data: any;

  constructor(injector: Injector,
    private formBuilder: FormBuilder) {
    super(injector);
    // init form
    this.form = this.formBuilder.group({});
  }

  ngOnInit(): void {
    // load form
    this.loadForm();
  }

  // load form
  private loadForm() {
    if (this.layout) {
      // make sure form shoule initialize
      this.layout.form['controlResult'] = this.prepareForm(this.formBuilder, this.layout.form.controls);
      // clone form
      this.cloneFormGroup(this.layout.form.controlResult.formGroup, this.form);
      // set form items
      this._formItems = this.layout.form.controlResult.forms;
      // process patch value
      if (this.data) {
        this.layout.form.action.onPatchValue(this.form, this._formItems, this.data);
      }
      // process prepare value
      this.layout.form.action.onPrepareValue(this.form, this._formItems, this.data);
    }
  }

  handleOnAction(action: INgxCrudAction): void {
    // service call
    if (action.serviceCall) {
      // get form value
      const formValue = _.cloneDeep(this.form.getRawValue());
      // execute command
      this.layout.form.action.onExecute(formValue, action, this.data, result => {
        if (NgxUtility.isSuccessResult(result)) {
          // call back
          this.onAction.emit({ action, result });
        }
      });
    } else {
      this.onAction.emit({ action });
    }
  }

  ngOnDestroy(): void {
    this.dispose();
  }

}
